import {createSlice} from "@reduxjs/toolkit";

export const permissionsSlice = createSlice(
    {
        name: 'permissions',
        initialState:{
            permissions:[],
            loading:true
        },
        reducers:{
            setPermissions:(state,{payload})=>{
                state.permissions = payload;
                state.loading = false
            },
            setLoading:(state,{payload})=>{
                state.loading = payload;
            }
        }
    }
);

export const {setPermissions,setLoading} = permissionsSlice.actions;

export default permissionsSlice.reducer;